import {Component, ElementRef, Input} from '@angular/core';
import {WebsiteSpotPage} from '../../website-spot';

@Component({
    selector: 'hc-address',
    templateUrl: 'hc-address.html',
    providers: []
})
export class HcAddress {

    //@Input('hpage')   hpage: WebsiteSpotPage;
    @Input('blocked') blocked: any;
    @Input('index') index: number;
    @Input('first') first: boolean;

    @Input('hpage')
    set hpageSet(data: WebsiteSpotPage) {

        this.hpage = data;

    }

    hpage: WebsiteSpotPage;

    constructor(public element: ElementRef) {

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-spot/components/hc-address/hc-address.ts